module.exports = __webpack_public_path__ + "static/media/postcard4.c707fc36.jpg";